import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-product-pics',
  templateUrl: './product-pics.component.html',
  styleUrls: ['./product-pics.component.css']
})
export class ProductPicsComponent implements OnInit {
    prodId;

    public itemsListProductPictures: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadProductPictures() {
        if (!!this.prodId) {
            this.itemsListProductPictures = await this.datatask.Post(1065, { prod_id: this.prodId });
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'productpic':
                this.stateService?.go('productpic', {
                    productpicturebank_keyno: '0',
                    prod_id: this.prodId
                });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadProductPictures();
    }

    ngOnInit() {
        this.init();
    }
}
